import { lazy } from "react";
// Module B — High Risk Patient Surveillance (Surveillance Panel)
// Pacientes de alto riesgo sin care management, priorizados por score compuesto.

const HighRiskSurveillancePage = lazy(() => import("./pages/HighRiskSurveillancePage"));
// Export routes for AppRouter
export const highRiskSurveillanceRoutes = [
  {
    path: "/high-risk-surveillance",
    element: <HighRiskSurveillancePage />,
  },
];

// Export components for external use
